// ── GENERAL / SHARED FIELDS (not tied to a specific vendor type) ──

export const ALL_LANGUAGES = [
  'English', 'Spanish', 'French', 'Mandarin', 'Cantonese', 'Japanese', 'Korean',
  'Vietnamese', 'Tagalog', 'Arabic', 'Hindi', 'Portuguese', 'Italian', 'German',
  'Russian', 'Other',
];

export const DIVERSITY_TAGS = [
  'Asian-Owned', 'Black-Owned', 'Hispanic/Latinx-Owned', 'LGBTQ+',
  'Native American-Owned', 'Pacific Islander-Owned', 'Veteran-Owned', 'Women-Owned',
];

export const VENUE_AMENITIES = [
  'Parking', 'Wheelchair Accessibility', 'On-Site Accommodations', 'Backup Rain Plan',
];

export const EVENT_HOURS = [
  '12:00 AM', '1:00 AM', '2:00 AM', '3:00 AM', '4:00 AM', '5:00 AM',
  '6:00 AM', '7:00 AM', '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM',
  '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM',
  '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM', '10:00 PM', '11:00 PM',
];

// Shared option lists used across vendor registration, profile editing,
// and admin review pages. Consolidated here to avoid the same list
// being hand-typed (and risking drift) in multiple files.

export const ALL_VENDOR_TYPES = [
  'Venue', 'Photography', 'Videography', 'Hair & Makeup', 'DJs', 'Bands',
  'Musicians', 'Caterers', 'Planners', 'Cakes & Bakeries', 'Florists',
  'Officiants', 'Photo Booths', 'Wedding Attire', 'Transportation',
  'Rentals/Décor/Lighting', 'Invitations & Stationery',
];

export const VENUE_TYPES = [
  'Barns and Farms',
  'Rooftops and Lofts',
  'Parks',
  'Boats',
  'Churches and Temples',
  'Outdoor',
  'Indoor',
  'Hotel',
  'Country Club',
  'Restaurants',
  'Gardens',
  'Waterfronts',
  'Mansions',
  'Museums',
  'Beaches',
  'Wineries and Breweries',
  'Historic Sites',
  'Banquet Halls',
];

export const US_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY',
];

export const US_STATE_NAMES = {
  AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
  CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'District of Columbia',
  FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois',
  IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana',
  ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan',
  MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri', MT: 'Montana',
  NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey',
  NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota',
  OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania',
  RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota',
  TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia',
  WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming',
  PR: 'Puerto Rico',
};

export const PHOTO_STYLES = [
  'Cinematic', 'Contemporary', 'Documentary', 'Editorial', 'Film', 'Natural',
  'Photo Journalism', 'Traditional', 'Vintage',
];

export const PHOTO_SERVICES = [
  'Additional Hours', 'Boudoir Shoot', 'Destination/Travel', 'Engagement Shoot',
  'High-Res Images', 'One Event/Day', 'Second Shooter', 'Video', 'Wedding Portraits',
  'Multiple Locations', 'Digital Files', 'Drone', 'Custom Graphics', 'Client Revisions',
  'Full Feature Video', 'High-Def Video', 'Highlight Video', 'Multiple Cameras',
  'Raw Footage', 'Slideshow/Montage', 'Hand Coloring', 'Content Creation',
];

export const PHOTO_ITEMS = [
  'Albums', 'Canvas', 'Digital Files', 'Flush Mount', 'Matted Prints', 'Negatives',
  'Prints', 'Proofs', 'Save-The-Date', 'Thank You Cards', 'Toning',
];

export const DJ_BAND_SERVICES = [
  'Ceremony Music', 'Reception Entertainment', 'Cocktail Hour',
  'Music During Breaks', 'Rehearsal Dinner', 'MC',
];

export const DJ_GENRES = [
  'Club', 'Country', 'Electronic', 'Hip Hop', 'Indie', 'International',
  'Oldies', 'Pop', 'R&B/Soul', 'Rock', 'Top 40', 'South Asian',
];

export const BAND_GENRES = [
  'Acoustic', 'Big Band', 'Blues', 'Caribbean', 'Classic Rock', 'Classical',
  'Country', 'Dance', 'Folk', 'Funk', 'Hip Hop', 'Jazz', 'Latin', 'Motown',
  'Oldies', 'Orchestra', 'Pop', 'R&B/Soul', 'Reggae', 'Rock', 'Strings', 'Swing',
];

export const BAND_MUSICIAN_SERVICES = [
  'Instrumentals', 'Learning New Song', 'Vocals', 'Soloist/Vocalist',
];

export const DJ_BAND_EQUIPMENT = [
  'Sound System', 'Lighting',
];

export const DJ_BAND_CUSTOMIZATIONS = [
  'Do Not Play List', 'Song Requests', 'Custom Playlists', 'Karaoke',
  'Disco Ball', 'Fog Machine', 'Projector',
];

export const CATERER_SPEC = ['Food Services', 'Bar Services'];

export const SERVICE_STYLES = [
  'Plated', 'Buffet', 'Family-Style', 'Food Stations', 'Food Truck',
  'Cocktail-Style', 'Coffee Bar', 'Chocolate Fountain',
];

export const FOOD_CONCEPTS = [
  'Formal', 'Multi-Course', 'Casual', 'Comfort Food', 'Themed', 'Fusion',
];

export const DIETARY_OPTIONS = [
  'Vegetarian', 'Vegan', 'Gluten Free', 'Lactose Free', 'Nut Free', 'Halal',
  'Kosher', 'Organic',
];

export const CUISINE_TYPES = [
  'African', 'American', 'Asian', 'BBQ', 'Caribbean', 'French', 'German',
  'Greek', 'Indian', 'Italian', 'Latin American', 'Local', 'Mediterranean',
  'Mexican', 'Middle Eastern', 'Seafood', 'Southern', 'Spanish',
];

export const FOOD_SERVICE_OPTIONS = [
  'Setup', 'Cleanup', 'Delivery', 'Cake', 'Cake Cutting', 'Dessert',
  'Cocktail Reception', 'Server(s)', 'Tastings', 'Chairs', 'Tables', 'China',
  'Linens', 'Flatware', 'Breakfast/Brunch', 'Custom Menu', "Hors d'oeuvres",
];

export const BAR_STYLES = [
  'Open Bar', 'Limited Bar', 'House Liquor', 'Specialty Beer', 'Specialty Wine',
  'Champagne Toast', 'Premium Liquor', 'Signature Drink', 'Alcohol Provided',
  'BYO', 'Dry Bar', 'Coffee Bar', 'Mobile/Vintage Bar', 'Self-Serve Stations',
  'Chocolate Fountain',
];

export const BAR_SERVICE_OPTIONS = [
  'Chairs', 'Tables', 'Barware', 'China', 'Flatware', 'Glassware', 'Linens',
  'Chocolate Fountain',
];

export const HM_SPEC = ['Hair', 'Makeup'];

export const HM_BASICS = ['Bridal Hair/Makeup', 'Wedding Party', "Men's Grooming"];

export const HM_LOCATIONS = ['On-Site', 'Salon'];

export const HAIR_SERVICES = [
  'Blowouts', 'Coloring', 'Haircuts', 'Extensions', 'Textured Hair Styling',
  'Updos/Styling', 'Hair Trial', 'Keratin', 'Trial Sessions',
];

export const MAKEUP_SERVICES = [
  'Airbrush', 'Contour', 'Eye', 'Natural', 'Trial', 'Fake Lashes',
  'Tattoo Coverage', 'Spray Tanning', 'Facials', 'Skincare', 'Brow/Lash Tinting',
];

export const FLORIST_STYLES = [
  'Classic & Traditional', 'Wild, Whimsical & Boho', 'Modern & Minimalist',
  'Romantic & Lush', 'Tropical & Bold',
];

export const FLORIST_SERVICES = [
  'Consultations', 'Delivery', 'Event Designs', 'Samples', 'Set Up',
  'Venue Visit', 'Ceremony', 'Reception', 'Clean Up', 'Floral Preservation',
  'Wholesale/Bulk', 'Candle Rental',
];

export const PLANNING_LEVELS = [
  'Full-Planning', 'Partial Planning', 'Day Of Coordination', 'Month Of Planning',
  'Month Of Coordination',
];

export const PLANNER_SERVICES = [
  'Vendor Management/Coordination', 'Timeline Creation', 'Budget Planning',
];

export const PLANNER_EVENTS = [
  'Ceremony', 'Reception', 'Rehearsal Dinner', 'Engagement Party',
];

export const PLANNER_EVENT_EXPERIENCE = [
  'Civil', 'Cultural', 'Destination', 'Double Wedding', 'Elopement',
  'Eco-Friendly', 'Non-Religious', 'Religious', 'Military',
];

export const DESSERT_TYPES = [
  'Wedding Cakes', 'Grooms Cake', 'Pastries', 'Cupcakes', 'Cookies',
  'Croquembouche', 'Donuts', 'Dessert Buffet', 'Fruit',
];

export const CAKE_SERVICES = [
  'Consultations', 'Custom Design', 'Delivery', 'Setup', 'Tastings',
];

export const CAKE_ITEMS = [
  'Cake Toppers', 'Cake Stand', 'Cake Serving Set', 'Dessert Stands',
];

export const WEDDING_EVENT_TYPES = [
  'Non-Religious', 'Interfaith', 'Ceremony Rehearsal', 'Vow Renewal', 'Civil Union',
];

export const RELIGIOUS_AFFILIATIONS = [
  'Agnostic', 'Anglican', "Baha'i Faith", 'Baptist', 'Buddhist', 'Catholic',
  'Earth-Based', 'Episcopalian', 'Evangelical', 'Hindu', 'Jewish', 'Lutheran',
  'Methodist', 'Mormon', 'No Denomination', 'Orthodox Christian', 'Pagan',
  'Presbyterian', 'Quaker', 'Unitarian', 'Other',
];

export const FLEET_TYPES = [
  'SUV Limo', 'Standard Limo', 'Stretch Limo', 'Sedan', 'Van', 'Classic Car',
  'Motor Coach', 'Shuttle', 'Exotic Car', 'Trolley', 'Party Bus',
];

export const TRANSPORT_SERVICES = [
  'Round Trip', 'One-Way Trip', 'Multi-Location', 'Valet', 'Directing Traffic',
];

export const VEHICLE_AMENITIES = [
  'Bottled Water', 'Ice', 'DVD Player', 'Fiber Optics Lighting', 'Flat Screen TVs',
  'Premium Stereo System', 'Bar', 'Privacy Partition', 'Red Carpet Service',
  'Wedding Signage',
];

export const SPECIAL_TRANSPORTATION = ['Animals', 'Golf Cart', 'Jet'];

export const ATTIRE_SPEC = ['Wedding Dress', 'Bridal Party', 'Suit/Tuxedo'];

export const TURN_AROUND_MIN_TIMES = [
  '1 Week', '2 Weeks', '3 Weeks', '1 Month', '2 Months', '3 Months', '4 Months',
  '5 Months', '6 Months', '7 Months', '8 Months', '9 Months', '10 Months',
  '11 Months', '12 Months',
];

export const TURN_AROUND_MAX_TIMES = [
  '2 Weeks', '3 Weeks', '1 Month', '2 Months', '3 Months', '4 Months',
  '5 Months', '6 Months', '7 Months', '8 Months', '9 Months', '10 Months',
  '11 Months', '12 Months', '12 Months+',
];

export const NEW_GOWN_OPTIONS = ['Weekly', 'Monthly', 'Annually', 'Seasonally'];

export const DRESS_SERVICES = [
  'Alterations', 'Custom Design', 'Sample Sizes', 'Trunk Show', 'Rentals',
  'Appointments Only', 'Sample Sales', 'Cleaning', 'Preservations', 'Warranties',
  'Full Customization', 'Shoes',
];

export const ADDITIONAL_ATTIRE_ITEMS = [
  'Bridal Belts', 'Garters', 'Hair Accessories', 'Jewelry', 'Plus Size Gowns',
  'Sample Gowns', 'Veils', 'Undergarments',
];

export const WEDDING_PARTY_FOR = [
  'Bridesmaids', 'Father Of The Bride', 'Father Of The Groom', 'Groom',
  'Groomsmen', 'Ring Bearers', 'Flower Girls', 'Mother Of The Bride',
  'Mother Of The Groom',
];

export const RETURN_POLICIES = ['Final Sales', 'Exchanges', 'Full Refund', 'Partial Sale'];

export const PHOTO_BOOTH_SERVICE_OPTIONS = [
  'Backdrop(s)', 'Enclosed Booth', 'Flip Book', 'Prints', 'Props',
  'Social Media Integration', 'Professional Attendant', 'Digital Image',
  'Stand Alone Booth', 'Studio Quality Equipment', 'Onsite Printing',
  'Instant Sharing', 'Gallery', 'Filters', 'Email Sharing', 'Virtual Props',
  'CD/DVD Of Images',
];

export const PHOTO_BOOTH_MODES = ['Photo', 'Video', 'Boomerang', 'GIF', 'Sketch Bots'];

export const SPECIALTY_RENTALS = [
  'Mobile Events', 'Photo Booth', 'Restrooms', 'Audio Guestbook', 'Animals',
  'Drone Show', 'Pet Attendant', 'Graffiti Wall', 'Generators',
];

export const MOBILE_EVENT_TYPES = ['Golf', 'Axe Throwing', 'Tattoo Artist', 'Other'];

export const EVENT_ITEMS = [
  'Tent Accessories', 'Tents', 'Aisle Markers', 'Aisle Runners', 'Altar/Arch',
  'Audio Equipment', 'Centerpieces', 'Chair Covers', 'Chairs', 'Chuppah',
  'Dance Floor', 'Décor', 'Drapery', 'Lights', 'Lounge Furniture', 'Mandaps',
  'Signage', 'Tables', 'Trinkets', 'Vases', 'Fencing', 'Horse Carriage',
];

export const FOOD_BEVERAGE_ITEMS = [
  'Barware', 'China', 'Chocolate Fountain', 'Flatware', 'Glassware', 'Linens',
];

export const RENTAL_TIME_MIN_OPTIONS = [
  'No Min', '30 Minutes', '1 Hour', '2 Hours', '3 Hours', '4 Hours', '5 Hours',
  '6 Hours', '7 Hours',
];

export const RENTAL_TIME_MAX_OPTIONS = [
  '1 Hour', '2 Hours', '3 Hours', '4 Hours', '5 Hours', '6 Hours', '7 Hours',
  '8 Hours', '9 Hours', '10 Hours', '11 Hours', '12 Hours', 'No Max',
];

export const AVAILABILITY_OPTIONS = [
  'In-House Available', 'In-House Required', 'Not Available', 'Outside Allowed',
];

export const RENTAL_SERVICES = ['Delivery', 'Setup', 'Clean Up', 'Showroom'];

export const INVITATION_PRODUCTS = [
  'Catalog Invitations', 'Custom Invitations', 'Imprinted Napkins', 'Menus',
  'Place Cards', 'Save-The-Dates', 'Programs', 'RSVP Cards', 'Thank You',
];

export const INVITATION_SERVICES = [
  'Assembly', 'Calligraphy', 'Design', 'Embossed', 'Engraving', 'Letterpress',
  'Printing',
];

export const INVITATION_CUSTOMIZATIONS = ['Design Styles', 'Printing Methods'];